/**
 * Author:hong.rong
 * Desc:时间通用文件类
 */

export class DateHelper {
  /**
   * 格式化时间: 刚刚、xx分钟前、xx小时前、xx年-xx月-xx日 xx时:xx分
   * @param timeStr
   */
  public static timeFormat(timeStr: string) {
    const now = new Date();
    const current = new Date(timeStr);
    // 计算时间间隔，单位为分钟
    const inter = Math.floor((now.getTime() - current.getTime()) / 1000 / 60);
    if (inter === 0) {
      return '刚刚';
    }
    if (inter < 60) {
      return `${inter}分钟前`;
    }
    if (inter < 60 * 24) {
      return `${Math.floor(inter / 60)}小时前`;
    }
    const year: string = `${current.getFullYear()}`;
    let month: number | string = current.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    const date: string = `${current.getDate()}`;
    const hour: string = `${current.getHours()}`;
    let minutes: number | string = current.getMinutes();
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    if (`${now.getFullYear()}` === year) {
      return `${month}-${date} ${hour}:${minutes}`;
    }
    return `${year}-${month}-${date} ${hour}:${minutes}`;
  }

  /**
   * 格式化秒为00:00
   * @param seconds
   * @returns {string}
   */
  static secondFormat(seconds: number = 0) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds / 60) % 60);
    const s = Math.floor(seconds % 60);
    const mString = m >= 10 ? `${m}` : `0${m}`;
    const sString = s >= 10 ? `${s}` : `0${s}`;
    if (h > 0) {
      const hString = h >= 10 ? `${h}` : `0${h}`;
      return `${hString}:${mString}:${sString}`;
    }
    return `${mString}:${sString}`;
  }
}
